import React from 'react';
import {Container }  from 'react-bootstrap';

const Header = ( ) => {
  return (
    <Container className="header" fluid>
      <p className="headerText m-0 p-0">CRANBURRY</p>
      <a href='/' className='m-0 p-0'>
        <img src="./images/CranburryLogo.svg" className="headerLogo" alt="Cranburry Commons logo" />
      </a>
      <p className="headerText m-0 p-0">COMMONS</p>
    </Container>
  );
};

export default Header;
